module.exports = __webpack_public_path__ + "img/Website_Cover.a3d5f624.jpg";